import clsx from 'clsx';
import { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useAxios from '../../axios/useAxios';
import { PHONE_PASSWORD_LOGIN, PHONE_NUMBER_VERIFY, LOGIN } from '../../constants/routes';
import { auth } from '../../firebase/firebaseConfig';
import {
  handlePhoneNumberSubmission,
  isPhoneValid,
} from '../../utils/phoneNumber';
import PrimaryButton from '../button/PrimaryButton';
import { PhoneInputComponent } from './PhoneInput';
import { deployScan } from '../../utils/guestModeTrigger';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import logoGoogleLogin from '../../styles/img/google-icon-logo-svg.svg';
import { useGoogleAuth } from '../../context/GoogleAuthContext';
import { posthogPhoneNumberEvent } from '../../posthog/phoneNumberEvent';
import { POSTHOG_CAPTURE_PHONE_SIGN_IN_SMS, POSTHOG_CAPTURE_PHONE_SIGN_UP_SMS } from '../../posthog/constants';

export const HomeDrawer = () => {
  const [focused, setFocused] = useState(false);
  const [isShowOtherMethods, setIsShowOtherMethods] = useState(false);
  const { store } = useSelector((state) => state.store);
  const user = useSelector((state) => state.user);
  const location = useLocation();
  const entryQr = location.state?.entryQr || localStorage.getItem('entryQr') || '';
  const cartItems = useSelector((state) => state.cart.cartItems);

  const dispatch = useDispatch();
  const [number, setNumber] = useState('');
  const [, setIsOpen] = useState(false);
  const [isValidNumber, setIsValidNumber] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const axiosInstance = useAxios();
  const { initiateGoogleLogin } = useGoogleAuth();

  const isButtonOtherMethodClicked = useRef(null);

  useEffect(() => {
    if (focused) {
      setIsOpen(true);
    }
  }, [focused]);


  useEffect(() => {
    setIsValidNumber(isPhoneValid(number));
  }, [number]);

  useEffect(() => {
    const localNumber = localStorage.getItem('phoneNumber');
    if (localNumber) {
      setNumber(localNumber);

      setTimeout(() => {
        setFocused(true);
      }, 1000);
    }
  }, []);

  const handleContinue = async () => {
    setFocused(true);
    if (!isValidNumber) return;
    let normalizedNumber = number;
    if (number.startsWith('330')) {
      normalizedNumber = number.replace('330', '33');
    }
    localStorage.setItem('phoneNumber', normalizedNumber);
    const result = await handlePhoneNumberSubmission({
      phoneNumber: normalizedNumber,
      auth,
      axiosInstance,
      onUserExists: (formattedNumber) => {
        posthogPhoneNumberEvent(POSTHOG_CAPTURE_PHONE_SIGN_IN_SMS, { phoneNumber: formattedNumber })
        navigate(PHONE_PASSWORD_LOGIN, {
          state: { phoneNumber: formattedNumber, userExists: true },
        });
      },
      onUserNew: (formattedNumber) => {
        posthogPhoneNumberEvent(POSTHOG_CAPTURE_PHONE_SIGN_UP_SMS, { phoneNumber: formattedNumber })
        navigate(PHONE_NUMBER_VERIFY, {
          state: { phoneNumber: formattedNumber, userExists: false },
        });
      },
      onError: (error) => {
        console.error('Phone submission error:', error);
      },
      setLoading: setIsLoading,
      recaptchaContainerId: 'home-drawer-recaptcha',
    });

    console.info('Phone submission result:', result);
  };

  const handleOtherMethods = () => {
    setIsShowOtherMethods(true);
    isButtonOtherMethodClicked.current = true;
  };

  const handleBlur = () => {
    if (isButtonOtherMethodClicked.current) {
      const inputPhoneNumber = document.querySelector('[name="phone-number-input-drawer"]');
      if (inputPhoneNumber) {
        inputPhoneNumber.blur();

        setTimeout(() => {
          isButtonOtherMethodClicked.current = null;
        }, 500);
      }
    }
    else {
      setFocused(false);
    }
  };

  const renderPhoneAndOtherMethods = () => {
    return (
      <>
        <PrimaryButton
          label={isLoading ? 'Chargement...' : 'Continuer'}
          onClick={handleContinue}
          disabled={!isValidNumber || isLoading}
          onMouseDown={(event) => event.preventDefault()}
          style={{
            opacity: isValidNumber && !isLoading ? 1 : 0.5,

          }}
        />

      {/*{isShowOtherMethods ?*/}
      {/*  {*/}
      {/*  renderOtherMethods()*/}
      {/*  }*/}
        {/*:*/}
        <button
          type="button"
          className="geomanistMedium -mt-4 text-2xl p-6 underline rounded-full w-full"
          onMouseDown={(event) => event.preventDefault()}
          onClick={() => navigate(LOGIN)}
        >
          Autres méthodes
        </button>
      {/*}*/}
    </>
    )
  }

  const renderOtherMethods = () => {
    return (
      <div className="flex flex-col items-center justify-start w-full pt-6 pb-14 gap-10">

        <div className="my-4 h-1 opacity-10 bg-black w-full" />

        <PrimaryButton
          className="!shadow-[0px_4px_0px_0px_rgba(0,0,0,0.1)] "
          style={{
            background: '#ffffff',
            border: '2px solid #E6E6E6',
          }}
          onMouseDown={(event) => event.preventDefault()}
          onClick={initiateGoogleLogin}
        >
          <img src={logoGoogleLogin} alt="google" className="h-10"/>
          <span className="ml-3">Google</span>
        </PrimaryButton>

        <PrimaryButton
          label="E-mail"
          onMouseDown={(event) => event.preventDefault()}
          onClick={() => navigate(LOGIN)}
          className=" !shadow-[0px_4px_0px_0px_rgba(0,0,0,0.1)] "
          style={{
            background: '#ffffff',
            border: '2px solid #E6E6E6',
          }}
        />
      </div>
    )
  }

  return (
    <>
      <div
        className={clsx(
          'h-[100dvh] w-[100dvw] pointer-events-none fixed top-0 left-0 right-0 bottom-0 z-40 transition-all duration-300',
          focused && 'bg-black opacity-75 pointer-events-auto',
        )}
        onClick={() => { setIsOpen(false); setFocused(false); }}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            setIsOpen(false);
            setFocused(false);
          }
        }}
        role="button"
        tabIndex={0}
      />
      <div
        className={clsx("w-[100dvw] transition-all duration-500 ease-out bg-white rounded-t-[20px] p-6 px-12 shadow-[0px_2px_40px_0px_rgba(0,0,0,0.3)] " +
                          "fixed bottom-0 left-0 right-0 z-50 border-t-2 border-gray-200" +
                        "overflow-y-auto overflow-x-hidden"
        )}
         style={{
            height: focused ? '62dvh' : '170px'}}
        >
      {focused ? <h1 className="text-3xl geomanistMedium font-medium w-full text-start my-12">Bienvenue !</h1> : null}

        <div className="flex flex-col items-center justify-center gap-8">
          <PhoneInputComponent
            value={number}
            onChange={setNumber}
            defaultCountry="fr"
            onFocus={() => setFocused(true)}
            onBlur={handleBlur}
          />

          {focused ? renderPhoneAndOtherMethods()
            :
            <PrimaryButton
              label="Mode invité"
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => deployScan({
                store,
                user,
                entryQr,
                dispatch,
                axiosInstance,
                navigate,
                cartItems,
              })}
              className=" !shadow-[0px_4px_0px_0px_rgba(0,0,0,0.1)] "
              style={{
                background: '#ffffff',
                border: '2px solid #E6E6E6',
              }}
            />
          }
        </div>

        {/* Hidden reCAPTCHA container */}
        <div id="home-drawer-recaptcha" style={{ display: 'none' }} />
      </div>
    </>
  );
};
